/**
 * Barra de acción sticky en la parte inferior del CxPPanel cuando hay
 * facturas seleccionadas. Permite mover en batch, cambiar forma de pago
 * en batch o pagar agrupado por proveedor.
 *
 * Extraído de CxPPanel.jsx en Iter 236.m.14 (Carlos). Cobertura E2E:
 * specs/CxPPanel.spec.ts (`batch-actions-bar` / `btn-batch-mover` /
 * `btn-batch-pagar` / `btn-batch-clear`).
 */
import { Button } from '../../ui/button';
import { Check, Plus } from 'lucide-react';
import BatchFormaPagoDropdown from '../BatchFormaPagoDropdown';

export function BatchActionsBar({
  count,
  busy,
  selectedIds,
  onClear,
  // Iter 236.p (Carlos): `onAbrirMover` se mantiene en props por compatibilidad,
  // pero el botón "Mover fecha" se eliminó (creaba múltiples nóminas en batch).
  onAbrirMover,
  onAbrirPagar,
  onAbrirNominaEspecial,
  onFormaPagoApplied,
}) {
  if (count === 0) return null;
  return (
    <div
      className="sticky bottom-2 z-30 mt-2 rounded-md border bg-blue-600 text-white shadow-lg flex items-center justify-between gap-3 p-2.5"
      data-testid="batch-actions-bar"
    >
      <div className="flex items-center gap-2 text-sm">
        <span className="font-semibold tabular-nums" data-testid="batch-count">{count}</span>
        <span>factura{count === 1 ? '' : 's'} seleccionada{count === 1 ? '' : 's'}</span>
        <button
          type="button"
          className="ml-2 text-[11px] underline opacity-90 hover:opacity-100"
          onClick={onClear}
          data-testid="btn-batch-clear"
        >
          limpiar
        </button>
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="secondary"
          className="h-8 text-xs"
          disabled={busy}
          onClick={onAbrirMover}
          data-testid="btn-batch-mover"
          hidden
          style={{ display: 'none' }}
        >
          {/* Iter 236.p (Carlos): oculto. El batch mover-fecha creaba N nóminas */}
        </Button>
        {/* Iter 236.n+p (Carlos): crear nómina manual/extra con las seleccionadas */}
        {onAbrirNominaEspecial && (
          <Button
            size="sm"
            variant="secondary"
            className="h-8 text-xs"
            disabled={busy}
            onClick={onAbrirNominaEspecial}
            data-testid="btn-batch-nomina-especial"
          >
            <Plus className="w-3.5 h-3.5 mr-1" /> Nómina Manual
          </Button>
        )}
        {/* Iter 234.c (Carlos) — Dropdown forma de pago bulk */}
        <BatchFormaPagoDropdown
          selectedIds={selectedIds}
          disabled={busy}
          onApplied={onFormaPagoApplied}
        />
        <Button
          size="sm"
          className="h-8 text-xs bg-emerald-600 hover:bg-emerald-700 text-white"
          disabled={busy}
          onClick={onAbrirPagar}
          data-testid="btn-batch-pagar"
        >
          <Check className="w-3.5 h-3.5 mr-1" /> Pagar agrupado x proveedor
        </Button>
      </div>
    </div>
  );
}
